import React from 'react';
import './Standardsplaste.css';
import satanplas from '../../../imgs/satanplasti.webp';

const Standardsplaste = () => {
    return (
        <div className="Standardspl-container">
            <div className='Ordinarys'>
                <h2 className="Standardspl-title">What Are The Standards Size of Plastic Pallets?</h2>
                <p className="Standardspl-date">Dec. 7, 2022</p>
                <div className="Standardspl">
                    <img src={satanplas} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Standardspl-text">With the development of industrialization and the rise of mechanization,
                     pallets play an important role in more and more fields. Pallets make for efficient material handling 
                     and storage. Pallets are widely used in the logistics industry,
                     various industrial sectors, and the goods export industry.</p>
                <p className="Standardspl-text">Pallets are actually horizontal plates used to assemble stacked goods for
                     easy loading, unloading, and handling. Therefore, the height and size of the pallet should 
                     be adapted to the handling requirements of trucks,
                     forklifts, and other loading and unloading equipment.</p>
                <p className="Standardspl-text">At present, there are wooden, plastic,
                     and iron pallets on the market, as well as pallets of various new materials.
                      So plastic pallets characterized by anti-corrosion, moisture-proof, anti-rust, moth-proof,
                       and non-moldy are welcomed in many fields. Plastic pallets have so many advantages.
                     Then do you know the specifications of plastic pallets?</p>
                <p className="Standardspl-text">In fact, international pallets come in a variety of sizes,
                     pallet sizes vary depending on location and usage!</p>



            </div>

        </div>
    );
};

export default Standardsplaste;
